module.exports = __webpack_public_path__ + "static/media/insta.cf412d07.png";